// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Nl-z","tupacHeader":"Ol-z","tupacHeader2":"Pl-z","tupacMenu":"Ql-z","tupacMenu2":"Rl-z","tupacMain":"Sl-z","tupacMain2":"Tl-z"};